import { type Location, useNavigate } from "react-router";
import { IssueDetailPage } from "../../pages/IssueDetailPage";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";

/** The issue detail page in a dialog over `background`. Closing it returns the URL to `background`. */
export function IssueDetailModal({ background }: { background: Location }) {
  const navigate = useNavigate();
  return (
    <Dialog open onOpenChange={(open) => !open && navigate(background, { state: background.state })}>
      <DialogContent
        sheet={false}
        aria-describedby={undefined}
        className="top-8 bottom-8 block h-auto w-[min(calc(var(--container-9xl)+6rem),calc(100%-2rem))] max-w-none translate-y-0 overflow-y-auto px-4 py-6 sm:max-w-none sm:px-8 lg:px-12"
      >
        <DialogTitle className="sr-only">Issue</DialogTitle>
        <IssueDetailPage />
      </DialogContent>
    </Dialog>
  );
}
